// Lädt den Supabase-Client erst bei Bedarf nach.
// So landet die Library nicht im initialen JS-Bundle (besserer Mobile-PageSpeed).
export const getSupabase = () =>
  import("./client").then((m) => m.supabase);

export type LazySupabase = Awaited<ReturnType<typeof getSupabase>>;
